var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "3fb4530ae2b8f348710efb4484c65f7209d29c6d"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-es@rodi"] = {
  id: "3fb4530ae2b8f348710efb4484c65f7209d29c6d"
};